import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { SubmitButton } from '@/components/functional/Form/SubmitButton';
import { LinkButton } from '@/components/ui/Button/LinkButton/LinkButton';
import { hotLineFormActionsStyle } from '@/feature/hotline/component/HotLineFormActions/style';
/**
 * 匿名コンサルホットライン Form ボタン
 */
export const HotLineFormActions = (props) => {
    const { backTo, className = '', submitting = false, type } = props;
    const style = hotLineFormActionsStyle();
    const isInput = type === 'input';
    return (_jsxs("div", Object.assign({ className: style.base({ class: className }) }, { children: [_jsx(SubmitButton, Object.assign({ className: style.button(), color: isInput ? 'navy' : 'orange', disabled: submitting, loading: submitting, size: 'lg', type: 'submit' }, { children: isInput ? '入力内容を確認する' : '送信する' })), _jsx(LinkButton, Object.assign({ className: style.button(), color: 'gray', disabled: submitting, size: 'lg', to: backTo }, { children: "\u623B\u308B" }))] })));
};
